const Resume = (wallet) => {
    return  wallet.substr(0,5)  + "..." + wallet.substr(wallet.length - 5, 5)
}
export default Resume